module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "features features-home stats-page"
  }, [_c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column col-result first-col-result is-full"
  }, [_c('div', {
    staticClass: "features address-info"
  }, [_c('div', {
    staticClass: "start-info"
  }, [_vm._m(0), _c('div', {
    staticClass: "title-small"
  }, [_c('span', [_vm._v("Looking for your Address? Go to ")]), _c('span', {
    staticClass: "linkable",
    on: {
      "click": function($event) {
        return _vm.goTo('/address')
      }
    }
  }, [_c('span', [_vm._v("Address")])]), _c('span', [_vm._v(" in the top menu!")])])])]), _vm._m(1)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "title-mining"
  }, [_c('span', [_vm._v("Introducing  ")]), _c('span', {
    staticClass: "pink"
  }, [_vm._v("Accounts")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "features-bullets"
  }, [_c('div', {
    staticClass: "mb-20 coming-soon"
  }, [_vm._v("Coming up soon  🚀")]), _c('div', {
    staticClass: "mb-20"
  }, [_vm._v("Some things you will be able to do with your Account:")]), _c('ul', [_c('li', [_c('i', {
    staticClass: "fa fa-check-circle"
  }), _c('span', [_vm._v("Change the coin you are mining at any moment, with no downtime")])]), _c('li', [_c('i', {
    staticClass: "fa fa-check-circle"
  }), _c('span', [_vm._v("Distribute your hash rate between more than one coin at the same time")])]), _c('li', [_c('i', {
    staticClass: "fa fa-check-circle"
  }), _c('span', [_vm._v("Change your payout addresses at any time")])]), _c('li', [_c('i', {
    staticClass: "fa fa-check-circle"
  }), _c('span', [_vm._v("Set a custom payment threshold for each coin")])]), _c('li', [_c('i', {
    staticClass: "fa fa-plus-circle"
  }), _c('span', [_vm._v("And more!")])])]), _c('div', {
    staticClass: "mt-20"
  }, [_c('span', [_vm._v("Mining to an account won't require a coin name when connecting, just the account name and an optional worker name.")])]), _c('div', {
    staticClass: "mb-20 mt-5"
  }, [_c('span', [_vm._v("Also note that you will still be able to mine directly to an Address, ")]), _c('span', {
    staticClass: "w400"
  }, [_vm._v("balance and stats from Accounts and Addresses will be independant from each other.")])]), _c('hr'), _c('div', {
    staticClass: "suggestions"
  }, [_c('div', {
    staticClass: "mt-20 suggestions-title"
  }, [_vm._v("Are we missing something, or do you have a feature in mind? ")]), _c('div', {
    staticClass: "mt-5 suggestions-subtitle"
  }, [_c('span', [_vm._v("Send us an email at ")]), _c('a', {
    attrs: {
      "href": "mailto:support@unmineable.com"
    }
  }, [_vm._v("support@unmineable.com ")]), _c('span', [_vm._v(" and we will see what we can do!")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-164bc9fa","hasScoped":true}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/View_Account.vue
// module id = 362
// module chunks = 1